// InputBox.tsx
import React from "react";
import styled from "styled-components";

interface InputBoxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  color?: string;
  backgroundColor?: string;
  transparency?: boolean;
  border?: string;
  outline?: string;
  width?: string;
  height?: string;
  padding?: string;
  borderRadius?: string;
  textAlign?: string;
}

const Input = styled.input<InputBoxProps>`
  color: ${(props) => props.color || "#000000"};
  background-color: ${(props) =>
    props.transparency ? "rgba(0,0,0,0)" : props.backgroundColor || "#DFDFDF"};
  border: ${(props) => props.border || "none"};
  outline: ${(props) => props.outline || "none"};
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  padding: ${(props) => props.padding};
  border-radius: ${(props) => props.borderRadius};
  text-align: ${(props) => props.textAlign};
  ::placeholder {
    color: #000000;
    opacity: 1;
  }
`;

const InputBox = React.forwardRef<HTMLInputElement, InputBoxProps>(
  (props, ref) => {
    const {
      readOnly,
      disabled,
      type,
      placeholder,
      children,
      id,
      form,
      onChange,
      onClick,
      minLength,
      maxLength,
      required,
      list,
      value,
      ...rest
    } = props;

    return (
      <Input
        ref={ref}
        autoComplete="off"
        readOnly={readOnly}
        disabled={disabled}
        type={type}
        placeholder={
          placeholder || (typeof children === "string" ? children : undefined)
        }
        id={id}
        form={form}
        onChange={onChange}
        onClick={onClick}
        minLength={minLength}
        maxLength={maxLength}
        required={required}
        list={list}
        value={value}
        {...rest}
      />
    );
  }
);

export default InputBox;
